module.exports = __webpack_public_path__ + "static/media/aboutbanner_banner_right.f89aff31.png";